import React from 'react';
import { Icon } from '../../../../elements/icon';
import useCopy from '../useCopy';
import { REVIEWS_IO_LOGO, LIVE_IMAGES } from '../assets';

export const LiveImageSlide = ({ name, review = false }) => {
  const c = useCopy();
  const src = LIVE_IMAGES[name][c.lang] || LIVE_IMAGES[name].en;
  const alt = c.text(`PC_LiveAlt_${name}`);

  return (
    <div className={`live-wrap${review ? ' rev' : ''}`}>
      {review && (
        <div className="rev-strip">
          <span className="rev-ver">
            <Icon raw name="productCarouselCheck" />
            {c.text('PC_ReviewStrip_Verified')}
          </span>
          <img className="rev-logo" src={REVIEWS_IO_LOGO} alt="reviews.io" />
        </div>
      )}
      <img className="live" alt={alt} src={src} />
    </div>
  );
};
